export const ZONE_RESET_STATE = 'ZONE_RESET_STATE';
export const ZONE_CURRENT_ITEM = 'ZONE_CURRENT_ITEM';

export const ZONE_REQUEST_LOADING = 'ZONE_REQUEST_LOADING';
export const ZONE_REQUEST_SUCCESS = 'ZONE_REQUEST_SUCCESS';
export const ZONE_REQUEST_FAILED = 'ZONE_REQUEST_FAILED';

export const ZONE_CURRENT_ACTION = 'ZONE_CURRENT_ACTION';
export const ZONE_RESET_ACTION = 'ZONE_RESET_ACTION';